import { api } from 'app/api';

/**
 * @param {{ hspId:string, usrId:string, hsptlzRsvNo:string, contentCode:string }} params
 * @returns I-16
 */
export const getHsptlzFormCreatedFileInfo = async (params) => {
  return await api.get(`/dfd/api/if/web/v1/hsptlz-form-sign-file-create-info`, {
    params,
  });
};
